import { useState } from "react";
import { AssetPlanList } from "../models/asset";
import { fetchAssetsPlans } from "../api/fetchAssets";

function useAssetsPlans() {
    const [assetsPlans, setAssetsPlans] = useState<AssetPlanList[]>([]);

    const getAssetsPlans = async (assetIds: string[]) => {
        if(assetIds?.length) {
            const data = await fetchAssetsPlans(assetIds);
            setAssetsPlans([...assetsPlans, ...data]);
        }
    }

    return { assetsPlans, getAssetsPlans }
}

export default useAssetsPlans;